import { IconKey } from '../../icon-key.enum';

export default {
  // Sidebar
  [IconKey.SidebarDashboard]: 'fa-fw fa-regular fa-home',
  [IconKey.SidebarMyFleet]: 'fa-fw fa-regular fa-truck-plow',
  [IconKey.SidebarMaintenanceAndInspections]: 'fa-fw fa-regular fa-briefcase',
  [IconKey.SidebarMaintenanceAndInspectionsUpcoming]: 'fa-fw fa-regular fa-wrench',
  [IconKey.SidebarMaintenanceAndInspectionsHistory]: 'fa-fw fa-regular fa-history',
  [IconKey.SidebarReporting]: 'fa-fw fa-regular fa-chart-bar',
  [IconKey.SidebarReportingAvailable]: 'fa-fw fa-regular fa-square-poll-vertical',
  [IconKey.SidebarReportingAutomatic]: 'fa-fw fa-regular fa-rotate-right',
  [IconKey.SidebarNotifications]: 'fa-fw fa-regular fa-bell',
  [IconKey.SidebarTransfers]: 'fa-fw fa-regular fa-arrow-right-arrow-left',
  [IconKey.SidebarAutomatedTransfersOnTheRoad]: 'fa-fw fa-regular fa-arrow-right-arrow-left',
  [IconKey.SidebarAutomatedTransfersScheduled]: 'fa-fw fa-regular fa-arrow-right-arrow-left',
  [IconKey.SidebarExpand]: 'fa-regular fa-thumbtack-slash fa-fw',
  [IconKey.SidebarCollapse]: 'fa-regular fa-thumbtack fa-fw',
  [IconKey.SidebarAdministration]: 'fa-regular fa-gear fa-fw',
  [IconKey.SidebarAdministrationMaintenanceAndInspections]: 'fa-regular fa-wrench fa-fw',
  [IconKey.SidebarAdministrationManagement]: 'fa-regular fa-user-gear fa-fw',

  // Topbar
  [IconKey.TopbarAutomatedTransferIndicator]: 'fa-fw fa-regular fa-arrow-right-arrow-left',
  [IconKey.TopbarAttentionIndicator]: 'fa-fw fa-regular fa-exclamation-triangle',
  [IconKey.TopbarNotificationIndicator]: 'fa-fw fa-regular fa-bell-exclamation',
  [IconKey.TopbarNotificationAcknowledge]: 'fa-fw fa-regular fa-circle-check',
  [IconKey.TopbarInfo]: 'fa-fw fa-regular fa-circle-info',
  [IconKey.TopbarAppSwitcher]: 'fa-fw fa-solid fa-grid-round',
  [IconKey.TopbarUserSwitcherAvatar]: 'fa-fw fa-regular fa-user',
  [IconKey.TopbarUserSwitcherDropdown]: 'fa-fw fa-regular fa-chevron-down',

  // Breadcrumb
  [IconKey.BreadcrumbHomeButton]: 'fa-fw fa-regular fa-house-blank',
  [IconKey.BreadcrumbBackButton]: 'fa-fw fa-regular fa-arrow-left',
  [IconKey.BreadcrumbHelpSwitch]: 'fa-fw fa-solid fa-circle-question',
  [IconKey.BreadcrumbHelpCloser]: 'fa-fw fa-regular fa-xmark',

  // Filters & Search Bar
  [IconKey.SearchBarAutocompleteSuggestionIndicator]: 'fa-fw fa-regular fa-clock-rotate-left text-color-secondary',
  [IconKey.SearchBarClearer]: 'fa-fw fa-regular fa-times',
  [IconKey.FilterColumnSelector]: 'fa-fw fa-regular fa-line-columns',
  [IconKey.FilterColumnItemGrip]: 'fa-fw fa-regular fa-grip-dots-vertical',
  [IconKey.FilterColumnItemIndicator]: 'fa-fw fa-solid fa-check',
  [IconKey.FilterSelector]: 'fa-fw fa-regular fa-filter',
  [IconKey.FilterClearer]: 'fa-fw fa-regular fa-times',
  [IconKey.FilterActiveIndicator]: 'fa-fw fa-solid fa-circle-small',
  [IconKey.FilterOpen]: 'fa-fw fa-solid fa-angle-left',
  [IconKey.FilterClosed]: 'fa-fw fa-solid fa-angle-right',
  [IconKey.FilterToggle]: 'fa-solid fa-circle-info',

  // Map
  [IconKey.MapLocationSearch]: 'fa-fw fa-regular fa-location-dot',
  [IconKey.MapLayerEquipment]: 'fa-regular fa-truck-plow',
  [IconKey.MapLayerGeofence]: 'fa-regular fa-draw-polygon',
  [IconKey.MapLayers]: 'fa-fw fa-regular fa-layer-group',
  [IconKey.MapQuickFilter]: 'fa-fw fa-solid fa-angle-left',
  [IconKey.MapAddGeofence]: 'fa-regular fa-plus',
  [IconKey.MapStockGeofence]: 'fa-kit fa-stock',
  [IconKey.MapProjectGeofence]: 'fa-regular fa-map-location-dot',
  [IconKey.MapGlobalGeofence]: 'fa-regular fa-globe',
  [IconKey.MapDispositionGeofence]: 'fa-regular fa-arrow-right-arrow-left',
  [IconKey.MapAlarmGeofence]: 'fa-regular fa-bell',
  [IconKey.MapEditGeofence]: 'fa-regular fa-pen',
  [IconKey.MapDeleteGeofence]: 'fa-regular fa-trash-can',
  [IconKey.MapShowAllGeofences]: 'fa-layer-group fa-regular',
  [IconKey.MapInfoTelematicsEquipmentPosition]: 'fa-fw fa-regular fa-globe',
  [IconKey.MapClusterListItemJumpTo]: 'fa-regular fa-angle-right',
  [IconKey.MapZoomControlZoomIn]: 'fa-fw fa-solid fa-plus',
  [IconKey.MapZoomControlZoomOut]: 'fa-fw fa-solid fa-minus',
  [IconKey.MapTypeControlToggle]: 'fa-light fa-map',
  [IconKey.MapInfoOrganisationItem]: 'fa-regular fa-building',
  [IconKey.MapInfoOrganisationOpenDetails]: 'fa-regular fa-eye',
  [IconKey.MapInfoWindowClusterGlobalListGoBack]: 'fa-regular fa-arrow-left',

  // Reports
  [IconKey.ReportFormReset]: 'fa-fw fa-regular fa-xmark',
  [IconKey.ReportFormGenerate]: 'fa-fw fa-regular fa-wand-magic-sparkles',
  [IconKey.ReportCreateAutomaticReport]: 'fa-fw fa-regular fa-plus',
  [IconKey.ReportCardDefaultIcon]: 'fa-fw fa-light fa-file-exclamation',

  // Equipment Header
  [IconKey.EquipmentHeaderTelematicStatusSending]: 'fa-fw fa-solid fa-signal-stream fa-fade',
  [IconKey.EquipmentHeaderTelematicStatusNoData]: 'fa-fw fa-solid fa-signal-stream',
  [IconKey.EquipmentHeaderReportNewDamage]: 'fa-fw fa-regular fa-flag',
  [IconKey.EquipmentHeaderBackToTitle]: 'fa-regular fa-arrow-left-long',

  // Equipment Details
  [IconKey.EquipmentDetailsMapOpenInGoogleMaps]: 'fa-fw fa-regular fa-location-dot',
  [IconKey.EquipmentFavoriteIndicator]: 'fa-fw fa-solid fa-star',
  [IconKey.EquipmentDetailsSelectOrgEdit]: 'fa-regular fa-pencil',
  [IconKey.EquipmentDetailsStatusTotalWorkingHours]: 'fa-regular fa-calendar',
  [IconKey.EquipmentDetailsStatusTotalIdleHours]: 'fa-regular fa-clock',
  [IconKey.EquipmentDetailsTableCellFaultDisplay]: 'fa-duotone fa-solid fa-triangle-exclamation fa-2xl',

  // Equipment Attachments
  [IconKey.AttachmentsUpload]: 'fa-fw fa-regular fa-cloud-arrow-up',
  [IconKey.AttachmentsChooseFile]: 'fa-fw fa-regular fa-file-import',
  [IconKey.AttachmentsMarkAsDefaultImage]: 'fa-fw fa-regular fa-star',
  [IconKey.AttachmentsDefaultImage]: 'fa-fw fa-solid fa-star',
  [IconKey.AttachmentsAddLink]: 'fa-regular fa-plus',
  [IconKey.AttachmentsLink]: 'fa-regular fa-link',

  // Equipment Activity Status
  [IconKey.ActivityStatusWorking]: 'fa-fw fa-regular fa-circle-play',
  [IconKey.ActivityStatusIdling]: 'fa-fw fa-regular fa-clock',
  [IconKey.ActivityStatusStopped]: 'fa-fw fa-regular fa-circle-stop',
  [IconKey.ActivityStatusUnknown]: 'fa-fw fa-regular fa-circle-question',

  // Equipment Attention Status
  [IconKey.AttentionStatusGood]: 'fa-fw fa-regular fa-circle-check',
  [IconKey.AttentionStatusMachineFault]: 'fa-fw fa-regular fa-circle-xmark',
  [IconKey.AttentionStatusMaintenanceDue]: 'fa-fw fa-regular fa-wrench',
  [IconKey.AttentionStatusMachineFaultAndMaintenanceDue]: 'fa-fw fa-regular fa-circle-xmark',

  // Equipment Events
  [IconKey.EquipmentEventsAddEvent]: 'fa-fw fa-regular fa-calendar-circle-plus',
  [IconKey.EquipmentEventsAddWizardStepTypes]: 'fa-fw fa-regular fa-shapes',
  [IconKey.EquipmentEventsAddWizardStepDetails]: 'fa-fw fa-regular fa-bell',
  [IconKey.EquipmentEventsTypeIncident]: 'fa-fw fa-regular fa-triangle-exclamation',
  [IconKey.EquipmentEventsTypeOperatingHours]: 'fa-fw fa-regular fa-clock-five',
  [IconKey.EquipmentEventsTypeMileage]: 'fa-fw fa-regular fa-gauge-high',
  [IconKey.EquipmentEventsTypeDamage]: 'fa-fw fa-regular fa-car-burst',

  // Telematics
  [IconKey.TelematicsBatteryStatusHigh]: 'fa-fw fa-regular fa-battery-full',
  [IconKey.TelematicsBatteryStatusLow]: 'fa-fw fa-regular fa-battery-half',
  [IconKey.TelematicsBatteryStatusCritical]: 'fa-fw fa-regular fa-battery-low',
  [IconKey.TelematicsBatteryStatusUnknown]: 'fa-fw fa-regular fa-battery-exclamation',
  [IconKey.TelematicsEngineStatusRunning]: 'fa-fw fa-regular fa-engine',
  [IconKey.TelematicsEngineStatusWarning]: 'fa-fw fa-regular fa-engine-warning',

  // Global Icons
  [IconKey.GlobalListSwitchToList]: 'fa-fw fa-regular fa-list',
  [IconKey.GlobalListSwitchToMap]: 'fa-fw fa-regular fa-map',
  [IconKey.GlobalExport]: 'fa-fw fa-regular fa-cloud-arrow-down',
  [IconKey.GlobalExportFast]: 'fa-fw fa-regular fa-truck-fast',
  [IconKey.GlobalExportConfiguration]: 'fa-fw fa-regular fa-cog',
  [IconKey.GlobalSearch]: 'fa-fw fa-regular fa-magnifying-glass',
  [IconKey.GlobalSettings]: 'fa-fw fa-regular fa-cog',
  [IconKey.GlobalEdit]: 'fa-fw fa-solid fa-pen',
  [IconKey.GlobalCreate]: 'fa-fw fa-solid fa-plus',
  [IconKey.GlobalDelete]: 'fa-fw fa-solid fa-trash',
  [IconKey.GlobalCancel]: 'fa-fw fa-solid fa-xmark',
  [IconKey.GlobalFormReset]: 'fa-fw fa-solid fa-rotate-left',
  [IconKey.GlobalDefaults]: 'fa-fw fa-regular fa-circle-dot',
  [IconKey.GlobalApply]: 'fa-fw fa-solid fa-check',
  [IconKey.GlobalSave]: 'fa-fw fa-regular fa-floppy-disk',
  [IconKey.GlobalExclamation]: 'fa-fw fa-solid fa-circle-exclamation',
  [IconKey.GlobalButtonSpinner]: 'fa-duotone fa-solid fa-spinner-third fa-spin',
  [IconKey.GlobalActions]: 'fa-fw fa-solid fa-ellipsis-vertical',
  [IconKey.GlobalSort]: 'fa-fw fa-solid fa-sort',
  [IconKey.GlobalFormBack]: 'fa-fw fa-solid fa-arrow-left',
  [IconKey.GlobalFormNext]: 'fa-fw fa-solid fa-arrow-right',
  [IconKey.GlobalLinkTo]: 'fa-fw fa-solid fa-arrow-up-right-from-square',
  [IconKey.GlobalRefresh]: 'fa-fw fa-solid fa-arrows-rotate',
  [IconKey.GlobalBan]: 'fa-fw fa-solid fa-ban',
  [IconKey.GlobalInfo]: 'fa-fw fa-solid fa-circle-info',
  [IconKey.GlobalLegal]: 'fa-fw fa-solid fa-section',
  [IconKey.GlobalClose]: 'fa-fw fa-solid fa-xmark',
  [IconKey.GlobalSortAsc]: 'fa-fw fa-regular fa-arrow-down-a-z',
  [IconKey.GlobalSortDesc]: 'fa-fw fa-regular fa-arrow-up-z-a',

  // UI Elements
  [IconKey.UIExpandableTableCollapse]: 'fa-fw fa-regular fa-angle-up',
  [IconKey.UIExpandableTableExpand]: 'fa-fw fa-regular fa-angle-down',
  [IconKey.UITableSort]: 'fa-fw fa-solid fa-sort',
  [IconKey.UITableSortUp]: 'fa-fw fa-solid fa-duotone fa-sort-up',
  [IconKey.UITableSortDown]: 'fa-fw fa-solid fa-duotone fa-sort-down',
  [IconKey.UITableLoading]: 'fa-duotone fa-solid fa-spinner-third fa-spin',
  [IconKey.UITableSelectionActionDropdown]: 'fa-fw fa-regular fa-chevron-down',
  [IconKey.UISelectRemoveToken]: 'fa-fw fa-regular fa-xmark',
  [IconKey.UISelectErase]: 'fa-fw fa-regular fa-times',
  [IconKey.UIChipRemoveToken]: 'fa-fw fa-regular fa-xmark',
  [IconKey.UITreeTableExpand]: 'fa-fw fa-regular fa-circle-caret-down',
  [IconKey.UITreeTableCollapse]: 'fa-fw fa-regular fa-circle-caret-up',
  [IconKey.UIExpandedRow]: 'fa-fw fa-regular fa-diagram-subtask',
  [IconKey.UIInputDisplayFalse]: 'fa-solid fa-dash',
  [IconKey.UIInputDisplayTrue]: 'fa-solid fa-play',
  [IconKey.UIInputDisplayUnknown]: 'fa-solid fa-question',

  // Settings Icons
  [IconKey.SettingsTableViewNormal]: 'fa-fw fa-regular fa-grip-lines',
  [IconKey.SettingsTableViewCondensed]: 'fa-fw fa-regular fa-line-columns',

  // Help Icons
  [IconKey.HelpTip]: 'fa-solid fa-bell-on',
  [IconKey.HelpNote]: 'fa-fw fa-solid fa-exclamation-circle',
  [IconKey.HelpWarning]: 'fa-regular fa-triangle-exclamation',

  // File Types
  [IconKey.FileTypeCSV]: 'fa-fw fa-fw fa-regular fa-file-csv',
  [IconKey.FileTypeExcel]: 'fa-fw fa-fw fa-regular fa-file-spreadsheet',
  [IconKey.FileTypePDF]: 'fa-fw fa-regular fa-file-pdf',
  [IconKey.FileTypeDOC]: 'fa-fw fa-regular fa-file-doc',
  [IconKey.FileTypeMSWORD]: 'fa-fw fa-regular fa-file-word',
  [IconKey.FileTypePPT]: 'fa-fw fa-regular fa-file-ppt',
  [IconKey.FileTypeJPG]: 'fa-fw fa-regular fa-file-jpg',
  [IconKey.FileTypeImage]: 'fa-fw fa-regular fa-file-image',
  [IconKey.FileTypeSVG]: 'fa-fw fa-regular fa-file-svg',
  [IconKey.FileTypePNG]: 'fa-fw fa-regular fa-file-png',
  [IconKey.FileTypeGIF]: 'fa-fw fa-regular fa-file-gif',
  [IconKey.FileTypeText]: 'fa-fw fa-regular fa-file-lines',
  [IconKey.FileTypeZIP]: 'fa-fw fa-regular fa-file-zip',
  [IconKey.FileTypeRAR]: 'fa-fw fa-regular fa-file-archive',
  [IconKey.FileTypeMP3]: 'fa-fw fa-regular fa-file-mp3',
  [IconKey.FileTypeAudio]: 'fa-fw fa-regular fa-file-audio',
  [IconKey.FileTypeMP4]: 'fa-fw fa-regular fa-file-mp4',
  [IconKey.FileTypeMOV]: 'fa-fw fa-regular fa-file-mov',
  [IconKey.FileTypeVideo]: 'fa-fw fa-regular fa-file-video',
  [IconKey.FileTypeXML]: 'fa-fw fa-regular fa-file-xml',
  [IconKey.FileTypeFile]: 'fa-fw fa-regular fa-file',

  // Dashboard Widget
  [IconKey.DashboardWidgetEdit]: 'fa-fw fa-regular fa-pen',
  [IconKey.DashboardWidgetDelete]: 'fa-fw fa-regular fa-trash-can',
  [IconKey.DashboardWidgetMove]: 'fa-fw fa-regular fa-grip-lines',

  // Maintenance Category Icons
  [IconKey.MaintenanceCategoryReminder]: 'fa-regular fa-bell',
  [IconKey.MaintenanceCategoryCheck]: 'fa-regular fa-suitcase',
  [IconKey.MaintenanceCategoryCheckAndRepair]: 'fa-regular fa-wrench',
  [IconKey.MaintenanceCategoryStandalone]: 'fa-regular fa-screwdriver-wrench',

  // Maintenance Plan Assigned Equipment
  [IconKey.MaintenancePlanAssignedEquipment]: 'fa-fw fa-regular fa-truck-plow',
  [IconKey.MaintenancePlanCreatePlan]: 'fa-fw fa-regular fa-plus',
  [IconKey.MaintenancePlanAssign]: 'fa-fw fa-regular fa-link-simple',
  [IconKey.MaintenancePlanSelectPlans]: 'fa-fw fa-regular fa-file-lines',
  [IconKey.MaintenancePlanFillSelectPlans]: 'fa-fw fa-regular fa-file-lines',

  // Maintenance Plan Create Form
  [IconKey.MaintenancePlanCreateFormDescription]: 'fa-fw fa-regular fa-wrench',
  [IconKey.InspectionPlanCreateFormDescription]: 'fa-fw fa-regular fa-briefcase',
  [IconKey.MaintenancePlanCreateFormGeneralDataStep]: 'fa-fw fa-regular fa-file-lines',
  [IconKey.MaintenancePlanCreateFormRulesStep]: 'fa-fw fa-kit fa-notes',
  [IconKey.MaintenancePlanRemoveRule]: 'fa-regular fa-trash-can',
  [IconKey.MaintenancePlanRemoveCondition]: 'fa-regular fa-trash-can',

  [IconKey.CompleteMaintenanceTaskCompletionInfo]: 'fa-fw fa-regular fa-suitcase',
  [IconKey.CompleteMaintenanceTaskAdditionalInfo]: 'fa-fw fa-regular fa-file-lines',

  //Interval Card
  [IconKey.TimeInterval]: 'fa-fw fa-regular fa-timer',
  [IconKey.SpecificDate]: 'fa-fw fa-regular fa-calendar-day',
  [IconKey.MileageInterval]: 'fa-fw fa-regular fa-gauge-high',
  [IconKey.OperatingHoursInterval]: 'fa-fw fa-regular fa-clock-nine',

  // Automated Transfers
  [IconKey.TransferPaused]: 'fa-fw fa-regular fa-circle-pause',
  [IconKey.ScheduledTransferAccordionTogglerInactive]: 'fa-fw fa-regular fa-chevron-down',
  [IconKey.ScheduledTransferAccordionTogglerActive]: 'fa-fw fa-regular fa-chevron-up',
  [IconKey.ScheduledTransferSliderIconProject]: 'fa-regular fa-location-dot',
  [IconKey.ScheduledTransferSliderIconStock]: 'fa-kit fa-stock',
  [IconKey.ScheduledTransferSliderIconRemainingTime]: 'fa-regular fa-clock',
  [IconKey.ScheduledTransferSortAsc]: 'fa-regular fa-arrow-up',
  [IconKey.ScheduledTransferSortDesc]: 'fa-regular fa-arrow-down',
  [IconKey.ScheduledTransferDeactivate]: 'fa-regular fa-power-off',
  [IconKey.ScheduledTransferTransferNow]: 'fa-fw fa-regular fa-arrow-right-arrow-left',
  [IconKey.ScheduledTransferRestartThresholdTimer]: 'fa-fw fa-regular fa-timer',
  [IconKey.ScheduledTransferCancelTransfer]: 'fa-fw fa-solid fa-ban',
  [IconKey.AutomatedTransferEquipment]: 'fa-regular fa-truck-plow',
  [IconKey.AutomatedTransferLocationSelect]: 'fa-regular fa-map-location-dot',
  [IconKey.AutomatedTransferTransferSummary]: 'fa-regular fa-circle-info',
  [IconKey.AutomatedTransferProject]: 'fa-regular fa-map-location-dot',
  [IconKey.AutomatedTransferStock]: 'fa-kit fa-stock',
  [IconKey.AutomatedTransferMapAddress]: 'fa-fw fa-regular fa-map',

  // Stock type
  [IconKey.StockTypePerson]: 'fa-fw fa-regular fa-person-carry',
  [IconKey.StockTypeContainer]: 'fa-fw fa-regular fa-container-storage',
  [IconKey.StockTypePosition]: 'fa-fw fa-regular fa-map-marked-alt',
  [IconKey.StockTypeVehicle]: 'fa-fw fa-regular fa-truck-ramp-box',
  [IconKey.StockTypeStock]: 'fa-fw fa-kit fa-stock',
  [IconKey.StockTypeMain]: 'fa-fw fa-regular fa-globe',

  // Equipment Employee Role
  [IconKey.EquipmentEmployeeRoleOwner]: 'fa-regular fa-briefcase-blank',
  [IconKey.EquipmentEmployeeRolePossessor]: 'fa-regular fa-coins',
  [IconKey.EquipmentEmployeeRolePersonInCharge]: 'fa-regular fa-user-helmet-safety',
  [IconKey.EquipmentEmployeeRoleDriver]: 'fa-regular fa-steering-wheel',
  [IconKey.EquipmentEmployeeRoleMaintenanceAssignee]: 'fa-regular fa-hammer',

  // Contact type
  [IconKey.ContactTypeGeneric]: 'fa-regular fa-address-card',
  [IconKey.ContactTypeCompany]: 'fa-regular fa-building',
  [IconKey.ContactTypeCoContractor]: 'fa-regular fa-digging',
  [IconKey.ContactTypeGravelPlant]: 'fa-regular fa-shovel',
  [IconKey.ContactTypeLandfill]: 'fa-regular fa-trash',
  [IconKey.ContactTypeLocation]: 'fa-regular fa-map-marked-alt',
  [IconKey.ContactTypeUnknown]: 'fa-regular fa-question',

  // Alarm type
  [IconKey.AlarmTypeOperatingHours]: 'fa-regular fa-clock',
  [IconKey.AlarmTypeOperatingHoursContract]: 'fa-regular fa-timer',
  [IconKey.AlarmTypeTankFillLevel]: 'fa-regular fa-gas-pump',
  [IconKey.AlarmTypeTotalCosts]: 'fa-regular fa-money-bill',
  [IconKey.AlarmTypeDamageCosts]: 'fa-regular fa-car-tilt',
  [IconKey.AlarmTypeRepairCosts]: 'fa-regular fa-hammer',
  [IconKey.AlarmTypeGuarantee]: 'fa-regular fa-badge-check',
  [IconKey.AlarmTypeFullServiceContractEnd]: 'fa-kit fa-regular-file-clock',
  [IconKey.AlarmTypeLeasingServiceContractEnd]: 'fa-regular fa-file-circle-info',
  [IconKey.AlarmTypeGlobalGeofenceViolation]: 'fa-regular fa-location-exclamation',
  [IconKey.AlarmTypeTimefencing]: 'fa-regular fa-hourglass-clock',
  [IconKey.AlarmTypeTransportTaskCreation]: 'fa-regular fa-truck-clock',
  [IconKey.AlarmTypeTransportTaskReturned]: 'fa-regular fa-truck-arrow-right',
  [IconKey.AlarmTypeNewDamageAdded]: 'fa-regular fa-car-burst',
  [IconKey.AlarmTypeInactiveTelematicsUnit]: 'fa-regular fa-wifi-exclamation',
  [IconKey.AlarmTypeBatteryVoltage]: 'fa-regular fa-battery-bolt',
  [IconKey.AlarmTypeDefTankLevel]: 'fa-regular fa-oil-can-drip',
  [IconKey.AlarmTypeTelematicsUnitBatteryStatus]: 'fa-regular fa-battery-exclamation',
  [IconKey.AlarmTypeFaults]: '',
  [IconKey.AlarmTypeGeofenceViolation]: '',
  [IconKey.AlarmTypeTheftProtection]: 'fa-regular fa-user-ninja',
  [IconKey.AlarmTypeFallback]: 'fa-regular fa-xmark',

  // Warning level
  [IconKey.WarningLevelOverdue]: 'fa-kit fa-warning-overdue',
  [IconKey.WarningLevelHigh]: 'fa-kit fa-warning-high',
  [IconKey.WarningLevelMedium]: 'fa-kit fa-warning-medium',
  [IconKey.WarningLevelLow]: 'fa-kit fa-warning-low',

  // Equipment telematic unit
  [IconKey.EquipmentTelematicUnitDefault]: 'fa-regular fa-router',

  // List Item Factory
  [IconKey.ListItemFactoryEquipment]: 'fa-regular fa-truck-plow',
  [IconKey.ListItemFactoryMaintenance]: 'fa-regular fa-truck-plow',
  [IconKey.ListItemFactoryOrganisation]: 'fa-regular fa-building',

  // Root toast
  [IconKey.RootToastError]: 'fa-regular fa-exclamation-circle',
  [IconKey.RootToastSuccess]: 'fa-regular fa-check-circle',
  [IconKey.RootToastWarn]: 'fa-regular fa-check-circle',
  [IconKey.RootToastNeutral]: 'fa-regular fa-exclamation-circle',

  // Positions
  [IconKey.PositionsTableCellCoordinates]: 'fa-solid fa-globe',

  // Notifications
  [IconKey.NotificationsFormAlarmType]: 'fa-regular fa-shapes',
  [IconKey.NotificationsFormAlarmDetails]: 'fa-regular fa-bell',

  // Migration Status
  [IconKey.MigrationStatusSuccess]: 'fa-fw fa-regular fa-circle-check',
  [IconKey.MigrationStatusFailure]: 'fa-fw fa-regular fa-circle-xmark',
};
